// extracted by mini-css-extract-plugin
export default {"bar":"ald_bottom-bar__bar__i9A2z"};